import { useTranslation } from 'react-i18next';

function Sliders() {
      const { t, i18n } = useTranslation();
      const currentLanguage = i18n.language;

      const getImagePath = (index) => {
            // Dil tr-TR olsa bile slider-tr klasörünü kullan
            const folderName = currentLanguage.startsWith('tr') ? 'tr' : currentLanguage;
            return require(`../images/slider-${folderName}/${index}.png`);
      };

      return (
            <>
                  <section className="slider-section" style={{
                        padding: "8rem 0",
                        backgroundColor: "#f8f8f8"
                  }}>
                        <div className="container">
                              <div className="slider-titles" style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginBottom: "4rem"
                              }}>
                                    <h2 style={{
                                          fontSize: "3rem",
                                          fontWeight: "bold"
                                    }}>{t('sliders.title1')}</h2>

                                    <div style={{
                                          maxWidth: "40%"
                                    }}>
                                          <h2 style={{
                                                fontSize: "3rem",
                                                fontWeight: "bold",
                                                marginBottom: "1rem"
                                          }}>{t('sliders.title2')}</h2>
                                          <p style={{
                                                fontSize: "1.6rem",
                                                color: "#706f7b"
                                          }}>{t('sliders.description')}</p>
                                    </div>
                              </div>

                              <div className="slider-container" style={{
                                    position: "relative"
                              }}>
                                    <div className="slider-wrapper" style={{
                                          display: "flex",
                                          overflow: "hidden",
                                          scrollBehavior: "smooth",
                                          gap: "2rem"
                                    }}>
                                          {Array.from({ length: 10 }, (_, i) => i + 1).map((num) => (
                                                <img
                                                      key={num}
                                                      src={getImagePath(num)}
                                                      alt={`slide ${num}`}
                                                      style={{
                                                            minWidth: "400px",
                                                            height: "250px",
                                                            objectFit: "cover",
                                                            borderRadius: "10px"
                                                      }}
                                                />
                                          ))}
                                    </div>

                                    <div style={{
                                          position: "absolute",
                                          bottom: "-90px",
                                          right: "20px",
                                          display: "flex",
                                          gap: "1rem"
                                    }}>
                                          <button
                                                className="slider-btn prev"
                                                style={{
                                                      backgroundColor: "#ff4c30ac",
                                                      border: "none",
                                                      borderRadius: "50%",
                                                      width: "60px",
                                                      height: "60px",
                                                      cursor: "pointer",
                                                      boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center"
                                                }}
                                                onClick={() => {
                                                      const slider = document.querySelector('.slider-wrapper');
                                                      slider.scrollLeft -= 420;
                                                }}
                                          >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                      <path d="M15 18l-6-6 6-6" />
                                                </svg>
                                          </button>

                                          <button
                                                className="slider-btn next"
                                                style={{
                                                      backgroundColor: "#ff4c30ac",
                                                      border: "none",
                                                      borderRadius: "50%",
                                                      width: "60px",
                                                      height: "60px",
                                                      cursor: "pointer",
                                                      boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center"
                                                }}
                                                onClick={() => {
                                                      const slider = document.querySelector('.slider-wrapper');
                                                      slider.scrollLeft += 420;
                                                }}
                                          >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                      <path d="M9 18l6-6-6-6" />
                                                </svg>
                                          </button>
                                    </div>
                              </div>
                        </div>
                        <div style={{
                              textAlign: "center",
                              marginBottom: "2rem",
                              marginTop: "17.5rem"
                        }}>
                              <h2 style={{
                                    fontSize: "3rem",
                                    color: "#ff4d30",
                                    fontWeight: "bold"
                              }}>
                                    {t('sliders.promoTitle')}
                              </h2>
                        </div>
                        <div >
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginTop: "5rem",
                                    marginBottom: "5rem"
                              }}>
                                    <video
                                          width="100%"
                                          height="auto"
                                          controls
                                          style={{
                                                maxWidth: "1000px",
                                                borderRadius: "10px",
                                                boxShadow: "0 4px 8px rgba(0,0,0,0.1)"
                                          }}
                                    >
                                          <source src={require("../images/video.mp4")} type="video/mp4" />


                                    </video>
                              </div>
                        </div>
                  </section>
            </>
      )
}

export default Sliders;
